define(["exports", "text!../../assets/github.css", "hyperhtml", "./utils", "./worker"], function (_exports, _github, _hyperhtml, _utils, _worker) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _github = _interopRequireDefault(_github);
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n      <style>\n        ", "\n      </style>\n    "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/highlight";
  _exports.name = name;
  const nextMsgId = (0, _utils.msgIdGenerator)("highlight");

  function getLanguageHint(classList) {
    return Array.from(classList).filter(item => item !== "highlight" && item !== "nolinks").map(item => item.toLowerCase());
  }

  async function highlightElement(elem) {
    elem.setAttribute("aria-busy", "true");
    const languages = getLanguageHint(elem.classList);
    let response;

    try {
      response = await sendHighlightRequest(elem.innerText, languages);
    } catch (err) {
      console.error(err);
      return;
    }

    const {
      language,
      value
    } = response;

    switch (elem.localName) {
      case "pre":
        elem.classList.remove(language);
        elem.innerHTML = "<code class=\"hljs".concat(language ? " ".concat(language) : "", "\">").concat(value, "</code>");
        if (!elem.classList.length) elem.removeAttribute("class");
        break;

      case "code":
        elem.innerHTML = value;
        elem.classList.add("hljs");
        if (language) elem.classList.add(language);
        break;
    }

    elem.setAttribute("aria-busy", "false");
  }

  function sendHighlightRequest(code, languages) {
    const msg = {
      action: "highlight",
      code,
      id: nextMsgId(),
      languages
    };

    _worker.worker.postMessage(msg);

    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error("Timed out waiting for highlight."));
      }, 4000);

      _worker.worker.addEventListener("message", function listener(ev) {
        const {
          data: {
            id,
            language,
            value
          }
        } = ev;
        if (id !== msg.id) return; // not for us!

        _worker.worker.removeEventListener("message", listener);

        clearTimeout(timeoutId);
        resolve({
          language,
          value
        });
      });
    });
  }

  async function run(conf) {
    // Nothing to highlight
    if (conf.noHighlightCSS) return;
    const highlightables = [...document.querySelectorAll("\n    pre:not(.idl):not(.nohighlight) > code:not(.nohighlight),\n    pre:not(.idl):not(.nohighlight),\n    code.highlight\n  ")].filter( // Filter pre's that contain code
    elem => elem.localName !== "pre" || !elem.querySelector("code")); // Nothing to highlight

    if (!highlightables.length) {
      return;
    }

    const promisesToHighlight = highlightables.filter(elem => elem.textContent.trim()).map(highlightElement);
    document.head.appendChild((0, _hyperhtml.default)(_templateObject(), _github.default));
    await Promise.all(promisesToHighlight);
  }
});
//# sourceMappingURL=highlight.js.map